import React from 'react';
import HeroImage from '../../../images/features/hida/hero.png';
import HeroBgSmImage from '../../../images/features/hida/hero-bg-sm.png';
import HeroBgImage from '../../../images/features/hida/hero-bg.png';
import { makeBackgroundImageStyles } from '../../core/styles';
import { useHeroStyles } from '../styles/hero';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Covid19Link } from '../covid19';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
  root: {
    ...makeBackgroundImageStyles(HeroBgSmImage),
    backgroundSize: '98% 100%',
    [theme.breakpoints.up('sm')]: {
      ...makeBackgroundImageStyles(HeroBgImage),
      backgroundSize: '98% 100%',
    },
    [theme.breakpoints.only('xs')]: {
      padding: theme.spacing(5, 0, 2.5),
    },
  },
  mainImg: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: theme.breakpoints.values.sm,
      width: '80%',
    },
  },
  box: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 5),
    },
  },
  main: {
    [theme.breakpoints.only('xs')]: {
      padding: 0,
    },
  },
  description: {
    '& p': {
      fontSize: theme.typography.pxToRem(16),
    },
    [theme.breakpoints.only('xs')]: {
      textAlign: 'left',
      paddingTop: theme.spacing(2),
    },
  },
}));

const Hero = () => {
  const classes = useHeroStyles({ classes: useStyles(), imgMaxSize: 600 });

  const description = (
    <>
      <div className={classes.description}>
        <Typography color="textPrimary">
          この度、岐阜県飛騨市とのコラボおてつたびがスタートしました。
        </Typography>
        <Typography color="textPrimary">
          自然豊かな里山の美しい原風景や匠の技が息づく飛騨市。様々な魅力をお手伝いを通じて感じながら素敵な旅をしよう！
        </Typography>
      </div>
      <Covid19Link />
    </>
  );

  return (
    <>
      <div className={classes.root}>
        <div className={classes.box}>
          <div className={classes.main}>
            <img src={HeroImage} className={classes.mainImg} />
          </div>
          <Hidden xsDown>{description}</Hidden>
        </div>
      </div>
      <Hidden smUp>{description}</Hidden>
    </>
  );
};

export default Hero;
